module.exports = __webpack_public_path__ + "img/babo-left.cc1a1ab3.png";